import { render, staticRenderFns } from "./ProductSummaryReport.vue?vue&type=template&id=aee4186c&"
import script from "./ProductSummaryReport.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductSummaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports